import { PlanningViewsResults } from '@common/data-models/navigation/planning-views-results';
import { PublicationChannelsResults } from '@common/data-models/publication-channels/publication-channels-results';
import { Record } from '@common/data-models/records/record';
import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { SearchResults } from '@common/data-models/search-results/search-results';
import { UsersResults } from '@common/data-models/search-results/users-result';
import { Layout } from '@common/data-models/service/layout';
import { IRealtimeUpdatesProvider } from '@common/interfaces/i-realtime-updates-provider';
import { Store } from '@ngrx/store';
import { isCollectionType } from '@src/suite/common/utils/record-utils';
// import { StoryRecord } from '@src/suite/common/data-models/records/story-record';
import { AppService } from '@suite/app.service';

// @Injectable({ providedIn: 'root' })
export class DataStore {
    public static store: Store;
    // constructor(private store: Store) {
    //     DataStore.store = this.store;
    // }

    public static realtimeUpdatesProviders: { [id: string]: IRealtimeUpdatesProvider } = {};
    public static addRealtimeUpdatesProvider(provider: IRealtimeUpdatesProvider, name?: string) {
        DataStore.realtimeUpdatesProviders[name || 'enps'] = provider;
    }

    public static appService: AppService;

    private static getKey(guid: string, providerName?: string): string {
        const prefix = providerName || 'enps';
        return `${prefix}_${guid}`;
    }

    private static getProviderName(key: string): string {
        return key.split('_')[0];
    }

    public static disposeRecordSimple(_rec: Record) {
        // if (rec instanceof CollectionRecord) {
        //     const children = rec.getChildren();
        //     for (const child of children) {
        //         delete DataStore.records[DataStore.getKey(child.guid)];
        //     }
        // }
        // delete DataStore.records[DataStore.getKey(rec.guid)];
    }

    public static disposeRecord(_rec: Record, _disposeChildren?: boolean, _providerName?: string) {
        // if (disposeChildren && rec instanceof CollectionRecord) {
        //     const childGuids: { [id: string]: boolean } = {};
        //     const children = rec.getChildren();
        //     for (const child of children) {
        //         childGuids[child.guid] = true;
        //         for (const key in DataStore._searchResults) {
        //             DataStore._searchResults[key].remove(child);
        //         }
        //     }
        //     for (const guid in childGuids) {
        //         if (DataStore.records[DataStore.getKey(guid, providerName)]) {
        //             if (DataStore.records[DataStore.getKey(guid, providerName)].parentChangedSub && !DataStore.records[DataStore.getKey(guid, providerName)].parentChangedSub.closed) {
        //                 DataStore.records[DataStore.getKey(guid, providerName)].parentChangedSub.unsubscribe();
        //             }
        //             DataStore.records[DataStore.getKey(guid, providerName)].parentRecord = null;
        //         }
        //         delete DataStore.records[DataStore.getKey(guid, providerName)];
        //     }
        // }
        // // Remove all references in all groupings
        // for (const key in DataStore._searchResults) {
        //     DataStore._searchResults[key].remove(rec);
        // }
        // for (const key in DataStore._viewStateResults) {
        //     DataStore._viewStateResults[key].remove(<ViewStateRecord>rec);
        // }
        // if (rec.parentRecord) {
        //     rec.parentRecord = null;
        // }
        // if (rec.links) {
        //     rec.links = null;
        // }
        // if (DataStore.records[DataStore.getKey(rec.guid, providerName)]) {
        //     if (DataStore.records[DataStore.getKey(rec.guid, providerName)].parentRecord) {
        //         DataStore.records[DataStore.getKey(rec.guid, providerName)].parentRecord = null;
        //     }
        //     if (DataStore.records[DataStore.getKey(rec.guid, providerName)].links) {
        //         DataStore.records[DataStore.getKey(rec.guid, providerName)].links = null;
        //     }
        // }
        // delete DataStore.records[DataStore.getKey(rec.guid, providerName)];
    }

    // RTU subscriptions
    public static rtuSubscriptions: { [id: string]: boolean } = {};

    // Data manipulation routines
    private static records: { [id: string]: Record } = {};
    public static byGuid<T extends Record>(guid: string, providerName?: string): T {
        const key = DataStore.getKey(guid, providerName);
        if (DataStore.records[key]) {
            return <T>(<any>DataStore.records[key]);
        }
        return null;
    }

    private static async subscribeToUpdatesForId(subscriptionId: string, providerName: string) {
        if (!DataStore.rtuSubscriptions[subscriptionId]) {
            DataStore.rtuSubscriptions[subscriptionId] = true;
            await DataStore.realtimeUpdatesProviders[providerName].subscribe(subscriptionId);
        }
    }

    public static async subscribeForPathUpdates(database: string, path: string, providerName?: string) {
        const subscriptionId = DataStore.realtimeUpdatesProviders[providerName || 'enps'].getSubscriptionIdForPath(database, path);
        this.subscribeToUpdatesForId(subscriptionId, providerName || 'enps');
    }

    public static async subscribeForRecordUpdatesV2(record: StorytellingRecord, providerName?: string) {
        if (record && record.Database && record.Path) {
            const subscriptionId = DataStore.realtimeUpdatesProviders[providerName || 'enps'].getSubscriptionIdV2(record);
            this.subscribeToUpdatesForId(subscriptionId, providerName || 'enps');
            if (isCollectionType(record.Type)) {
                // Subscribe for collection itself
                const collectionSubscriptionId = `${subscriptionId}\\R_${record.Guid}`;
                this.subscribeToUpdatesForId(collectionSubscriptionId, providerName || 'enps');
            }
            if (record.Path.groupId) {
                const trashSubscriptionId = `D=${record.Database}&P=P_${record.Path.groupId}\\T`;
                this.subscribeToUpdatesForId(trashSubscriptionId, providerName || 'enps');
            }
        }
    }

    public static async set(record: Record, providerName?: string, fromRTU?: boolean) {
        const { guid } = record;
        const storeKey = DataStore.getKey(guid, providerName);
        fromRTU = !!fromRTU;
        if (DataStore.records[storeKey]) {
            const fields: { [id: string]: any } = {};
            for (const field of record.keys) {
                if (fromRTU && field === 'LinkedRecords') {
                    continue;
                }
                fields[field] = record.get(field);
            }
            DataStore.records[storeKey].setFields(fields);
        } else {
            DataStore.records[storeKey] = record;
        }

        if (record.links && record.links.length > 0) {
            DataStore.records[storeKey].links = record.links;
        }
        // TODO REMOVE THIS
        // await DataStore.subscribeForRecordUpdates(DataStore.records[storeKey], providerName);
        // if (record.type === ObjectTypesEnum.SCRIPT) {
        //     this.store.dispatch(LiveApiActions.realtimeUpdateStory({ data: record }));
        // }
    }

    public static async setCollection(collection: any, hasChildren: boolean, providerName?: string, fromRTU?: boolean) {
        const collectionKey = DataStore.getKey(collection.guid, providerName);
        await DataStore.set(collection, providerName, fromRTU);

        const dataStoreCollection = <any>DataStore.records[collectionKey];
        if (collection.layout && dataStoreCollection && dataStoreCollection.layout !== collection.layout) {
            // Update layout
            if (!dataStoreCollection.layout) dataStoreCollection.layout = new Layout();
            dataStoreCollection.layout.update(collection.layout);
        }
        if (collection.sequence && collection.sequence.length > 0 && collection.getChildren().length === 0) {
            return;
        }
        if (collection.getChildren().length > 0 || hasChildren) {
            const dataStoreChildren: Array<Record> = [];
            const children = collection.getChildren();
            for (const child of children) {
                if (child.isCollection) {
                    await DataStore.setCollection(<any>child, false, providerName);
                } else {
                    await DataStore.set(child, providerName);
                }
                const dataStoreChild = DataStore.records[DataStore.getKey(child.guid, providerName)];
                dataStoreChildren.push(dataStoreChild);
            }

            if (dataStoreCollection) dataStoreCollection.setChildren(dataStoreChildren);
        }

        // if (collection.getStories().length > 0) {
        //     const dataStoreStories: Array<StoryRecord> = [];
        //     const stories = collection.getStories();
        //     for (const story of stories) {
        //         await DataStore.set(story, providerName);
        //         const dataStoreStory = DataStore.records[DataStore.getKey(story.guid, providerName)];
        //         dataStoreStories.push(dataStoreStory as StoryRecord);
        //     }
        //     if (dataStoreCollection) dataStoreCollection.setStories(dataStoreStories);
        // }
        // TODO REMOVE THIS
        // await DataStore.subscribeForRecordUpdates(DataStore.records[collectionKey], providerName);
    }

    private static async applyCollectionDiff(collection: any, providerName?: string) {
        const collectionKey = DataStore.getKey(collection.guid, providerName);
        const record = <any>DataStore.records[collectionKey];
        if (record) {
            for (const prop of collection.keys) {
                if (collection.get(prop)) record.set(prop, collection.get(prop));
            }

            const children = collection.getChildren();
            for (const child of children) {
                const childRecord = DataStore.records[DataStore.getKey(child.guid, providerName)];
                if (childRecord) {
                    for (const prop of child.keys) {
                        if (child.get(prop)) childRecord.set(prop, child.get(prop));
                    }
                    if (!record.hasChildWithGuid(child.guid)) {
                        record.addChildren(DataStore.byGuid<Record>(child.guid, ''));
                    }
                }
            }

            for (const removeGuid of collection.guidsToBeRemoved) {
                record.removeChildByGuid(removeGuid);
            }

            // Sort
            record.sortChildren((a: Record, b: Record) => a.scriptOrder - b.scriptOrder);
        }
        // // TODO: Remove this action and rework RTUs
        // if (record instanceof RundownRecord) {
        //     this.store.dispatch(LiveApiActions.realtimeUpdateRundown({ data: record as RundownRecord }));
        // }
    }

    public static disposePlanningViewsResults() {
        for (const view of DataStore.planningViewsResults.views) {
            DataStore.disposeRecord(view, false);
        }
        for (const search of DataStore.planningViewsResults.searches) {
            DataStore.disposeRecord(search, false);
        }
        for (const slideshow of DataStore.planningViewsResults.multiviews) {
            DataStore.disposeRecord(slideshow, false);
        }
        DataStore.planningViewsResults.dispose();
    }

    private static _searchResults: { [id: string]: SearchResults } = {};
    public static registerSearchResults(key: string, obj: SearchResults) {
        DataStore._searchResults[key] = obj;
    }
    public static getSearchResults<T extends SearchResults>(key: string): T {
        return <T>DataStore._searchResults[key];
    }
    public static get searchResultsKeys(): Array<string> {
        return Object.keys(DataStore._searchResults);
    }

    private static _viewStateResults: { [id: string]: PlanningViewsResults } = {
        playbook: new PlanningViewsResults(),
        discover: new PlanningViewsResults(),
        live: new PlanningViewsResults(),
        cast: new PlanningViewsResults(),
        journal: new PlanningViewsResults(),
    };
    public static registerViewStateResults(key: string, obj: PlanningViewsResults) {
        DataStore._viewStateResults[key] = obj;
    }
    public static getViewStateResults<T extends PlanningViewsResults>(key: string): T {
        return <T>DataStore._viewStateResults[key];
    }
    public static get viewStateResultsKeys(): Array<string> {
        return Object.keys(DataStore._viewStateResults);
    }
    public static getSingleViewStates(key: string): Array<ViewStateRecord> {
        let viewstates: Array<ViewStateRecord> = [];
        if (DataStore.getViewStateResults(key)) {
            for (const vs of DataStore.getViewStateResults(key).views) {
                viewstates.push(vs);
            }
            for (const vs of DataStore.getViewStateResults(key).searches) {
                viewstates.push(vs);
            }
        }

        viewstates = viewstates.sort((a: ViewStateRecord, b: ViewStateRecord) => {
            if (a.title < b.title) return -1;
            if (a.title > b.title) return 1;
            return 0;
        });
        return viewstates;
    }

    public static usersResults = new UsersResults();

    public static planningViewsResults = new PlanningViewsResults();

    public static publicationChannelsResults = new PublicationChannelsResults();

    public static markers = new Array<any>();

    private static _rtuListeners: { [id: string]: (rec: Record) => void } = {};

    public static registerRTUListener(key: string, f: (rec: Record) => void) {
        DataStore._rtuListeners[key] = f;
    }

    public static unregisterRTUListener(key: string) {
        delete DataStore._rtuListeners[key];
    }

    public static rtuHandler(_rec: Record, _providerName?: string) {
        // TODO FIX THIS
        // DataStore.updateMapMarker(rec);
        // if (rec instanceof CollectionRecord) {
        //     if (rec.isCollectionDiff) {
        //         DataStore.applyCollectionDiff(rec, providerName);
        //     } else {
        //         DataStore.setCollection(<CollectionRecord>rec, true, providerName, true);
        //     }
        // } else if (rec.type === ObjectTypesEnum.ASSIGNMENT || rec.type === ObjectTypesEnum.PUBLICATION || rec.type === ObjectTypesEnum.SCRIPT) {
        //     if (rec.path.isWasteBinPath) {
        //         // Assignment or publication deleted
        //         const existingRecord = DataStore.byGuid<Record>(rec.guid, '');
        //         if (existingRecord && !existingRecord.path.isWasteBinPath) {
        //             const collection = DataStore.byGuid<CollectionRecord>(existingRecord.path.parentCollectionGuid, '');
        //             if (collection) {
        //                 if (rec.parentChangedSub && !rec.parentChangedSub.closed) rec.parentChangedSub.unsubscribe();
        //                 rec.parentRecord = null;
        //                 // if (collection.type === ObjectTypesEnum.TOPIC && rec.type === ObjectTypesEnum.SCRIPT) {
        //                 //     collection.removeStoryByGuid(rec.guid);
        //                 // } else {
        //                 //     collection.removeChildByGuid(rec.guid);
        //                 // }
        //             }
        //         }
        //         DataStore.set(<Record>rec);
        //     } else {
        //         // Added or updated
        //         DataStore.set(<Record>rec);
        //         const collection = DataStore.byGuid<CollectionRecord>(rec.path.parentCollectionGuid, '');
        //         if (collection) {
        //             if (!collection.hasChildWithGuid(rec.guid)) {
        //                 // Need to add to collection
        //                 collection.addChildren(DataStore.byGuid<Record>(rec.guid, ''));
        //             }
        //         }
        //     }
        // } else {
        //     DataStore.set(<Record>rec);
        // }
        // for (const key in DataStore._rtuListeners) {
        //     DataStore._rtuListeners[key](DataStore.byGuid<Record>(rec.guid, ''));
        // }
    }

    // TODO: move to map and fix
    // private static async updateMapMarker(rec: Record) {
    //     const { guid } = rec;
    //     let lat: number = 0;
    //     let lng: number = 0;
    //     let found: boolean = false;
    //     if (rec.data && rec.data[PSTFieldNames.PSTTopicAddress]) {
    //         // topic or assignment
    //         lat = Number(rec.get('PSTTopicAddress').lat);
    //         lng = Number(rec.get('PSTTopicAddress').long);
    //         found = true;
    //     } else if (rec instanceof UserRecord) {
    //         // User Record Resource
    //         const user: UserRecord = rec as UserRecord;
    //         if (user.locations && user.locations.locations.length > 0) {
    //             lat = user.locations.getLastKnownLocation().latitude;
    //             lng = user.locations.getLastKnownLocation().longitude;
    //             found = true;
    //             // we also need to update the user resources list in appService
    //             if (DataStore.appService.userResources === null) {
    //                 DataStore.appService.userResources = [];
    //             }
    //             DataStore.appService.userResources.push(rec);
    //             if (!DataStore.markers.find(m => m.guid === rec.guid)) {
    //                 DataStore.appService.navigationService.currentListView.addUserToMap(rec);
    //             }
    //         }
    //     }
    //     if (found) {
    //         for (const marker of DataStore.markers) {
    //             if (marker.guid === guid) {
    //                 marker.latitude = lat;
    //                 marker.longitude = lng;
    //                 break;
    //             }
    //         }
    //     }
    // }

    public static dump() {
        console.log(`DataStore records: ${Object.keys(DataStore.records).length}`);
        // console.log(DataStore.records.length);
    }
}
